<template>
  <el-dialog
    v-model="dialogVisible"
    width="60%"
    destroy-on-close
  >
    <Container
      :title="t('pay.vitro')"
    >
      <template #main>
        <el-row>
          <el-col :span="13">
            <div
              style="text-align: left; padding-bottom: 30px; display: grid; grid-auto-flow: column; gap: 10px"
            >
              <i
                style="font-size: 18px; color:#ff4949; padding-bottom: 15px;"
                class="el-icon-warning"
              /><br>
              <span
                style="padding-bottom: 15px;"
              >{{ t('pay.vitroPayTip') }}</span>
            </div>
          </el-col>
        </el-row>
        <el-form
          :label-width="labelWidth"
          ref="cFormRef"
          label-position="left"
          style="margin-left:35%; font-size: 14px;"
        >
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.vendorName')"
                label-width="200px"
                style="text-align: left;"
              >
                <span>{{ vitroData.vendorName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('company.companyCode')"
                label-width="200px"
                style="text-align: left;"
              >
                <el-select
                  v-model="companyCodeValue"
                  class="filter-item"
                  :placeholder="t('form.selectPlaceholder')"
                  style="width:100%;"
                >
                  <el-option
                    v-for="(item) in companyCodeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.amount')"
                label-width="200px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(vitroData.amount) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.currency')"
                label-width="200px"
                style="text-align: left;"
              >
                <span>{{ vitroData.currency }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.paymentDate')"
                label-width="200px"
                style="text-align: left;"
              >
                <el-date-picker
                  v-model="selectedDate"
                  type="date"
                  :placeholder="t('common.selectDateTip')"
                  :default-value="new Date()"
                  :show-time="false"
                  :size="large"
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.purpose')"
                label-width="200px"
                style="text-align: left;"
              >
                <el-input
                  v-model="purposeInputValue"
                  placeholder="请输入内容"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.comment')"
                label-width="200px"
                style="text-align: left;"
              >
                <el-input
                  v-model="commentInputValue"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                :label="t('pay.uploadPaymentReceipt')"
                label-width="200px"
                style="text-align: left;"
              >
                <el-upload
                  ref="uploadFile"
                  drag
                  action=""
                  headers="getUploadHeader()"
                  multiple
                  :limit="1"
                  :auto-upload="false"
                  :on-change="handleUpload"
                  :on-exceed="handleExceed"
                >
                  <el-icon class="el-icon-upload">
                    <upload-filled />
                  </el-icon>
                  <div class="el-upload__text">
                    {{ $t('pay.uploadDropFile') }}{{ $t('pay.uploadDropOr') }} <em>{{ $t('pay.uploadDropClick') }}</em>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item
                label-width="200px"
                style="text-align: right; margin-top: 15px;"
              >
                <el-button
                  ref="opsButton"
                  class="order-button"
                  @click="handleCancel"
                >
                  {{ t('pay.cancel') }}
                </el-button>
                <el-button
                  ref="opsButton"
                  class="order-button"
                  type="primary"
                  @click="handleConfirmPay"
                >
                  {{ t('pay.confirmPay') }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
  </el-dialog>
</template>

<script lang="ts">

import { computed, defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import Container from '@/components/form/container/Container.vue'
import { useStore } from '@/store'
import { PaymentExternalUpdateModel } from '@/model/paymentSlip/paymentSlipModel'
// import { ElMessage } from 'element-plus'
import { paymentReceiptFileUpload } from '@/apis/paymentSlip/paymentSlip'
import { formatDate, formatThousands } from '@/utils'
import networkConfig from '@/config/default/net.config'
import { ElMessage } from 'element-plus'
import { CompanyListParamModel } from '@/model/master-data/companyModel'
import { getCompanyAllList } from '@/apis/main-data/company'
// import { UploadFilled } from '@element-plus/icons-vue'

export default defineComponent({
  name: 'VitroPayDialog',
  methods: { formatThousands },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    groupedSapList: {
      type: Array as () => number[],
      required: true,
      default: []
    },
    confirmText: {
      type: String,
      default: 'message.confirm'
    },
    cancelText: {
      type: String,
      default: 'message.cancel'
    },
    vitroData: {
      type: Object,
      required: true
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: { Container },
  emits: ['update:modelValue', 'update:vitroData', 'refresh'],
  setup(props, context) {
    const { t } = useI18n()
    const selectedDate = ref()
    const purposeInputValue = ref()
    const commentInputValue = ref()
    const updateUpload = ref()
    const uploadFile = ref()
    const externalPaymentUpload = ref()
    const companyCodeValue = ref()
    const dataInfo = ref<Object>(
      props.vitroData
    )
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const handleDownload = () => {
      console.log('handleDownload')
    }
    const handleCancel = () => {
      dialogVisible.value = false
    }
    const dataMap = reactive({
      BatchAddFile: [],
      companyCodeOptions: Array<string>(),
      getUploadUri() {
        return paymentReceiptFileUpload()
      },
      getUploadHeader() {
        return { Authorization: useStore().state.user.token }
      },
      async getCompanyCodes() {
        const params: CompanyListParamModel = {
          companyCode: null,
          name: null
        }
        const companyData = await getCompanyAllList(params)
        if (companyData?.data && companyData.data.length > 0) {
          companyData.data.forEach(item => {
            dataMap.companyCodeOptions.push(item.companyCode)
          })
          // dataMap.companyCodeOptions = companyData.data ?? []
        }
      }
    })
    const handleUpload = (files: any) => {
      dataMap.BatchAddFile = files.raw
    }
    const handleExceed = (files: any) => {
      uploadFile.value.clearFiles()
      const file = files[0]
      dataMap.BatchAddFile = file
      uploadFile.value.handleStart(file)
    }
    const handleConfirmPay = async() => {
      const params: PaymentExternalUpdateModel = {
        id: props.vitroData.id,
        companyCode: companyCodeValue.value,
        paymentDate: formatDate(selectedDate.value),
        purpose: purposeInputValue.value,
        comments: commentInputValue.value,
        paymentReceipt: updateUpload.value,
        file: dataMap.BatchAddFile
      }
      console.log(params)
      const formData = new FormData() as any
      formData.append('id', props.vitroData.id)
      formData.append('companyCode', companyCodeValue.value)
      formData.append('paymentDate', formatDate(selectedDate.value))
      formData.append('purpose', purposeInputValue.value)
      formData.append('comments', commentInputValue.value)
      formData.append('paymentReceipt', updateUpload.value)
      formData.append('file', dataMap.BatchAddFile)
      fetch(networkConfig.host + '/base/payment/slip/external/pay', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: useStore().state.user.token
        }
      }).then(response => {
        if (!response.ok) {
          ElMessage({
            message: 'Network response was not ok',
            type: 'error',
            duration: 2000
          })
        } else {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
          response.json()
          dialogVisible.value = false
          context.emit('refresh')
        }
      })
        .then(result => console.log(result))
        .catch(error => {
          ElMessage({
            message: error,
            type: 'error',
            duration: 2000
          })
        })
    }
    onMounted(() => {
      selectedDate.value = props.vitroData.paymentDate
      purposeInputValue.value = props.vitroData.purpose
      commentInputValue.value = props.vitroData.comments
      updateUpload.value = props.vitroData.paymentReceipt?.slice(props.vitroData.paymentReceipt.lastIndexOf('/') + 1)
      companyCodeValue.value = props.vitroData.companyCode
      dataMap.getCompanyCodes()
    })
    return {
      t,
      dialogVisible,
      dataInfo,
      selectedDate,
      purposeInputValue,
      commentInputValue,
      updateUpload,
      uploadFile,
      externalPaymentUpload,
      companyCodeValue,
      handleDownload,
      handleUpload,
      handleCancel,
      handleConfirmPay,
      handleExceed,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.header-title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.button-group {
  display: flex;
  justify-content: flex-end;

  .order-button {
    margin-left: 10px;
  }
}

</style>
